import { h, render } from 'preact';
import ProductContext from './product-context';
import ProductGallery from './product-gallery';
import ProductMainGallery from './product-main-gallery';
import ProductForm from './product-form';
import ProductMainForm from './product-main-form';
import BundleForm from './product-bundle-form';
import './klarna.css';

export default (element, data) => {
  const useNewPDPLayout = data.product.tags && data.product.tags.includes('useNewPDPLayout');

  const Product = ({ data: { isBundle } }) => (
    <div className="grid grid-cols-1 container--custom mx-auto pb-10 lg:gap-[50px] lg:grid-cols-12 lg:pb-[70px]">
      <div className="lg:col-span-7 lg:pt-10 lg:pl-[50px] lg:max-h-[700px] lg:sticky lg:top-[105px]">
        {useNewPDPLayout ? (
          <ProductMainGallery element={element} data={data} />
        ) : (
          <ProductGallery element={element} data={data} />
        )}
      </div>
      <div className="lg:col-span-5 px-5 lg:pl-1 lg:pr-[50px] lg:pt-10 product-form">
        {isBundle ? (
          <BundleForm />
        ) : useNewPDPLayout ? (
          <ProductMainForm element={element} data={data} />
        ) : (
          <ProductForm data={data} />
        )}
      </div>
    </div>
  );

  const init = () => {
    render(
      <ProductContext data={data}>
        <Product data={data} />
      </ProductContext>,
      element,
    );
  };

  init();
};
